import { defaultsHeadersAxios, setupStrapiHeaders } from '../services/apiService';
import { logger } from 'utils/logger';

interface HeadersConfig {
  token: string;
  organizationUUID?: string;
  cognitoUserPool?: string;
}

export const validateAndConfigureHeaders = async (config: HeadersConfig): Promise<boolean> => {
  const { token, organizationUUID, cognitoUserPool } = config;

  try {
    // 1. Validate token
    if (!token) {
      throw new Error('Token is required');
    }

    // 2. Validate and configure organizationUUID
    const orgUUID = organizationUUID || localStorage.getItem('x-organization-uuid');
    if (!orgUUID) {
      throw new Error('Organization UUID is required');
    }

    // 3. Validate and configure cognitoUserPool
    const userPool = cognitoUserPool || localStorage.getItem('x-cognito-userpool');
    if (!userPool) {
      throw new Error('Cognito User Pool is required');
    }

    // 4. Configure main headers
    defaultsHeadersAxios(token, orgUUID, userPool);

    // 5. Configure Strapi headers
    const isStrapiHeadersConfigured = setupStrapiHeaders(token, orgUUID, userPool);
    if (!isStrapiHeadersConfigured) {
      throw new Error('Failed to configure Strapi headers');
    }

    return true;
  } catch (error) {
    logger.error('Error configuring headers:', error);
    return false;
  }
};

export const getStoredHeaders = (): HeadersConfig => {
  return {
    token: localStorage.getItem('AUTH_TOKEN') || '',
    organizationUUID: localStorage.getItem('x-organization-uuid') || undefined,
    cognitoUserPool: localStorage.getItem('x-cognito-userpool') || undefined,
  };
};

// List of all header keys we use in localStorage
const HEADER_STORAGE_KEYS = [
  'x-organization-uuid',
  'x-cognito-userpool',
  'AUTH_TOKEN',
  'userData',
  'user_id',
  'menuTitle',
  'lastSelectedMenu',
] as const;

export const clearHeaders = (): void => {
  // Remove all known headers
  HEADER_STORAGE_KEYS.forEach(key => {
    localStorage.removeItem(key);
  });
};
